export const getItemsText = (item: string, count: number): string => (count > 1 ? `${item}s` : item);
